import { render, staticRenderFns } from "./Info_detail.vue?vue&type=template&id=06338ecf"
import script from "./Info_detail.vue?vue&type=script&lang=js"
export * from "./Info_detail.vue?vue&type=script&lang=js"
import style0 from "./Info_detail.vue?vue&type=style&index=0&id=06338ecf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports